<body class="footerStyle" > 
    <p class="textStyle">{{ version }}</p>
</body>